import React from 'react';
import OptionButton from '../OptionButton';

const Step6 = ({ data, onSelect, overrides }) => {
  const options = overrides?.options || [
    'Yes',
    'No',
    'Not sure'
  ];

  return (
    <div className="flex flex-col">
      {/* Question */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-8" style={{ color: '#1a1a2e' }}>
        {overrides?.question || 'Do you currently take a thyroid or hormone support supplement?'}
      </h1>

      {/* Options */}
      <div className="flex flex-col gap-3 items-start">
        {options.map((option) => (
          <OptionButton
            key={option}
            selected={data.takesSupplement === option}
            onClick={() => onSelect('takesSupplement', option)}
          >
            {option}
          </OptionButton>
        ))}
      </div>
    </div>
  );
};

export default Step6;
